import { IFundDataModel } from '../../data-models/fund.data-model';
import { IInitializedFormatter } from './IInitializedFormatter';

export class FundFormatter implements IInitializedFormatter<Map<number, IFundDataModel>, number | number[]> {
  #funds: Map<number, IFundDataModel> = new Map();

  init(funds: Map<number, IFundDataModel>) {
    this.#funds = funds;
    return this;
  }

  format = (value: number | number[] | null | undefined) => {
    if (Array.isArray(value)) {
      return value.map(this.#format).join(', ');
    }
    return this.#format(value);
  };

  #format = (value: number | null | undefined) => {
    if (value == null) {
      return '';
    }

    const fund = this.#funds.get(value);
    return fund ? FundFormatter.label(fund) : `Unknown fund id: ${value?.toString()}`;
  };

  // Option builders hold fund objects (some synthetic, e.g. "All Funds") rather than ids.
  static label(fund: Pick<IFundDataModel, 'name' | 'fundKind'>): string {
    return fund.fundKind === 'family' ? `${fund.name}${FamilyLabelSuffix}` : fund.name;
  }
}

export const NoGroupFundLabel = 'Other';

export const FamilyLabelSuffix = ' (Family)';
